export default __webpack_public_path__ + "static/media/Assessment.8b5cec33.jpg";